export enum AWARD_UPLOAD_TYPE {
  AWARD_PRELOAD = 'awardPreload',
  AWARD_ADJUMENT = 'awardAdjustment',
}

export enum BULK_UPLOAD_TYPE {
  AWARD_PRELOAD = 'PROMO_INVENTORY_PRELOAD',
  AWARD_ADJUMENT = 'PROMO_INVENTORY_ADJUST',
  CREDIT = 'CREDIT_ADJUSTMENT',
}

export enum BULK_UPLOAD_STATUS_TYPE {
  PROMO_INVENTORY_PRELOAD = 'awardPreload',
  PROMO_INVENTORY_ADJUST = 'awardAdjustment',
  CREDIT_ADJUSTMENT = 'credit',
}

export type BulkUploadStatusItem = {
  id: string;
  fileName: string;
  operationType: string;
  totalRecords: number;
  processedRecords: number;
  failedRecords: number;
  status: string;
  createdAt: string;
  progress?: number;
};

export type BulkUploadFailedItem = {
  row: number;
  error: string;
};

export const CREDIT_UPLOAD_TYPE = 'credit';
